import { constants, typographyStyles } from "@newsela/angelou";

import { pollOptionTextCss } from "../PollOptions.style";

const { colors } = constants;

export const responsePercentageCss = [
  {
    flexShrink: 0,
    fontWeight: "700",
    textAlign: "right",
    // We don't want the size of this to vary depending on the percentage
    width: "50px",
  },
  typographyStyles.fontSize.heading3,
];

export const pollOptionWithResultsCss = (responsePercentage) => {
  return [
    {
      border: `1px solid ${colors.ui.neutral[700]}`,
      marginLeft: "16px",
      position: "relative",

      // This is the percentage background color fill
      ":before": {
        background: colors.ui.core[500],
        content: '""',
        height: "100%",
        left: 0,
        position: "absolute",
        top: 0,
        width: `${responsePercentage}%`,
      },
    },
    pollOptionTextCss,
    typographyStyles.fontSize.textS,
  ];
};

export const pollOptionWithResultsTextCss = {
  position: "relative",
  zIndex: 1,
};
